import { render } from "./RegistrationSuccessScreen.vue?vue&type=template&id=01416220&scoped=true"
import script from "./RegistrationSuccessScreen.vue?vue&type=script&lang=js"
export * from "./RegistrationSuccessScreen.vue?vue&type=script&lang=js"

import "./RegistrationSuccessScreen.vue?vue&type=style&index=0&id=01416220&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01416220"]])

export default __exports__